import { combineReducers } from 'redux';
import UserReducer from './user';
import CustomerReducer from './customer';
import TimeRegistrationReducer from "../container/TimeRegistration/TimeReducer";
import LeadsReducer from '../container/Leads/LeadsReducer';
import LoginRducer from './login';
import LogoutReducer from './logout';
import RoutingReducer from './routing';
import CategoriesReducer from '../container/UserCategories/categoriesReducer'
import BranchesReducer from '../container/Branches/branchesReducer'
import ConsultantFunctionReducer from '../container/ConsultantFunction/consultantReducer'
import ThemeReducer from '../container/Themen/ThemesReducer'
import LandReducer from '../container/Land/LandReducer'
import ClassificationReducer from '../container/Classifications/ClassificationsReducer'
import SystemReducer from '../container/Systems/SystemsReducer'
import PublicHolidayReducer from '../container/PublicHoliday/HolidayReducer'
import UsersReducer from '../container/Users/usersReducer'
import ProjectsReducer from '../container/Projects/ProjectsReducer'
import MonthPlansReducer from '../container/MonthPlan/monthPlanReducer'
import BeraterplanReducer from '../container/Beraterplan/beraterplanReducer'
import CustomerOverviewReducer from '../container/OverviewReports/overviewReportsReducer'
import VacationOverviewReducer from '../container/VacationOverview/vacationOverviewReducer'
import ArchiveReducer from '../container/Archive/archiveReducer'
import ResourcePlanningReducer from '../container/ResourcePlanning/resourcePlanningReducer'

export default combineReducers({
  user: UserReducer,
  customer: CustomerReducer,
  timeRegistration: TimeRegistrationReducer,
  leads: LeadsReducer,
  login: LoginRducer,
  logout: LogoutReducer,
  routing: RoutingReducer,
  categories: CategoriesReducer,
  branches: BranchesReducer,
  consultant: ConsultantFunctionReducer,
  theme: ThemeReducer,
  land: LandReducer,
  classifications: ClassificationReducer,
  systems: SystemReducer,
  publicHoliday: PublicHolidayReducer,
  usersData: UsersReducer,
  projectsData: ProjectsReducer,
  monthPlan: MonthPlansReducer,
  beraterPlan: BeraterplanReducer,
  customerOverview: CustomerOverviewReducer,
  VacationOverview: VacationOverviewReducer,
  ArchiveReducer: ArchiveReducer,
  resource: ResourcePlanningReducer
});